export const MESSAGES_API_ENDPOINT = process.env.messagesApiEndpoint;